export const MATCHES_LOADED = "MATCHES_LOADED";
export const BEST_FIT_LOADED = "BEST_FIT_LOADED";
